/**
 * Extract a human-readable message from a thrown error.
 *
 * The api-client throws errors shaped like `{ error: { code, message, requestId } }`
 * (not standard `Error` instances), so naive `(e as Error).message` returns
 * undefined and the UI shows "unknown error". This helper checks every
 * common shape we see at runtime.
 */
export function apiErrorMessage(err: unknown, fallback = 'unknown error'): string {
  if (!err) return fallback;
  // api-client shape: { error: { code, message, requestId } }
  if (typeof err === 'object') {
    const e = err as { error?: { message?: string }; message?: string };
    if (e.error?.message) return e.error.message;
    if (e.message) return e.message;
  }
  if (typeof err === 'string') return err;
  return fallback;
}
